var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.orderId)?_c('Order',{ref:"order",staticClass:"h-100",attrs:{"order-id":_vm.orderId,"business-id":_vm.businessId},on:{"changed":_vm.changed,"forbidden":_vm.redirectToNextOrder}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }